declare const config
const FALLBACK_LOCALE = config.fallback_locale

export const I18N_FALLBACK_CONF: { [locale: string]: string[] } = {
    'en-DIOR': ['en', FALLBACK_LOCALE],
    'en-us': ['en', FALLBACK_LOCALE],
    'fr-DIOR': ['fr', FALLBACK_LOCALE],
    'fr-ca': ['fr', FALLBACK_LOCALE],
    'default': [FALLBACK_LOCALE],
}